import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";
const buttonVariants = cva("inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 active:scale-95", {
    variants: {
        variant: {
            default: "bg-primary text-primary-foreground hover:bg-primary/90",
            destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
            outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
            secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
            ghost: "hover:bg-accent hover:text-accent-foreground",
            link: "text-primary underline-offset-4 hover:underline",
        },
        size: {
            default: "h-11 px-4 py-2 min-w-[44px]", // 44px minimum touch target
            sm: "h-10 rounded-md px-3 min-w-[44px]", // 40px height, 44px min width
            xs: "h-9 rounded-md px-2 min-w-[44px]", // 36px height, 44px min width
            lg: "h-12 rounded-md px-8 min-w-[44px]", // 48px height, 44px min width
            icon: "h-11 w-11", // 44px x 44px minimum touch target
        },
    },
    defaultVariants: {
        variant: "default",
        size: "default",
    },
});
const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    return (_jsx(Comp, { className: cn(buttonVariants({ variant, size }), className), ref: ref, ...props }));
});
Button.displayName = "Button";
export { Button, buttonVariants };
